import { CouponsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useCouponsAPI(): CouponsApi {
  return new CouponsApi(apiConfig);
}
